import { useTranslation } from 'react-i18next';
import { Button } from 'components/ui/button';

export default function ScanStopped({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation();

  return (
    <div className='min-h-[calc(100vh-7rem)] grid place-content-center max-w-5xl mx-auto py-8 px-4'>
      <div className='flex flex-col max-w-md gap-4 mx-auto space-y-8'>
        <div className='space-y-8'>
          <h2 className='text-xl font-semibold text-center'>
            {t('scan_stopped')}
          </h2>
          <p className='mx-8 leading-tight text-center'>
            {t('scan_interrupted_message')}
          </p>
        </div>

        <div className='flex flex-col items-center justify-center gap-2'>
          <Button className='px-6 h-9' onClick={onClose}>
            {t('close')}
          </Button>
        </div>
      </div>
    </div>
  );
}
